module.exports = __webpack_public_path__ + "static/media/competition_skh.7c62fc67.png";